import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-archive-project',
  templateUrl: './archive-project.component.html',
  styleUrls: ['./archive-project.component.scss']
})
export class ArchiveProjectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
